import React from 'react';
import classNames from 'classnames';
import { List, Map } from 'immutable';

import { Paragraph, Taxonomy } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Hero, StickyButtons } from '../../../../components';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { SCREEN_NORMAL } from '../../../../config/constants';
import Buttons from './Buttons';

import './style.scss';

const NodeMunicipality = ({ entity, className }) => {
  const { width } = useWindowDimensions();

  const classes = classNames(className, 'NodeMunicipality', 'NodeMunicipality--full');
  const organizationEntity = entity.getIn(['field_organization', 0, 'entity'], '');

  const type = entity.getIn(['type', 0, 'target_id'], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const buttons = entity.get('field_buttons');

  const imageField = entity.getIn(['field_media_item', 0], Map());

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <Hero title={title} body={body} imageField={imageField} type={type} />
      <Container className="paragraph-group">
        <div className="row">
          <div className="col-lg-7 col-12 paragraph-group__wrapper">
            {buttons && width < SCREEN_NORMAL && <Buttons buttons={buttons} />}
            {entity.get('field_paragraphs') ? (
              <div className="NodeMunicipality__paragraphs">
                {entity.get('field_paragraphs', List()).map((paragraph) => {
                  const id = paragraph.get('target_id');
                  const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                  return (
                    <Paragraph
                      key={`paragraph:${id}:${language}`}
                      id={id}
                      entity={paragraph.get('entity')}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
          <div className="col-lg-4 col-12 offset-lg-1" id="sidebar">
            <div id="sidebar-content">
              <StickyButtons>
                {buttons && width >= SCREEN_NORMAL && <Buttons buttons={buttons} />}
              </StickyButtons>
              <div className="NodeMunicipality--full__organization">
                <Taxonomy entity={organizationEntity} />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </article>
  );
};

export default NodeMunicipality;
